import { useAppSelector } from 'src/app/reduxCustomHooks';

export type EditSaveStatus = 'idle' | 'saving' | 'error';

// Mutations that persist an edit of the document.
const EDIT_ENDPOINTS = new Set([
  'tasksControllerAddItem',
  'tasksControllerDeleteItem',
  'tasksControllerAddCustomBox',
  'tasksControllerUpdateBox',
  'tasksControllerChangeRedactState',
  'tasksControllerChangeVerify',
  'tasksControllerRedactAll',
  'tasksControllerUnRedactAll',
  'tasksControllerChangeItemsRedactState',
  'tasksControllerCreateLegalCode',
  'tasksControllerRemoveLegalCode',
]);

/** Saving while an edit is in flight; error if the latest edit was rejected. */
export const useEditSaveStatus = (): EditSaveStatus =>
  useAppSelector((state): EditSaveStatus => {
    const mutations = Object.values(state.api?.mutations ?? {});
    let latest: { status: string; startedTimeStamp?: number } | undefined;
    for (const mutation of mutations) {
      if (!mutation || !EDIT_ENDPOINTS.has(mutation.endpointName ?? '')) continue;
      if (mutation.status === 'pending') return 'saving';
      if (
        !latest ||
        (mutation.startedTimeStamp ?? 0) >= (latest.startedTimeStamp ?? 0)
      ) {
        latest = mutation;
      }
    }
    return latest?.status === 'rejected' ? 'error' : 'idle';
  });
